module.exports = __webpack_public_path__ + "img/ildkule-20121112-mini.1818dfc5.jpg";